import { AI_TOOL_SELECT_USAGE_NOTE } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { searchAiModelsInputSchema } from './aiModelAiToolInputSchemas';
import { aiModelsToolGroupIcon } from './toolGroupIcon';

export { searchAiModelsInputSchema };

export const searchAiModelsOutputSchema = z.object({
  results: z
    .array(z.unknown())
    .describe(
      'Matching AI models. Default minimal mask: id, modelName, integration (provider metadata), label, description. Shape follows expanded flat `select` when provided.',
    ),
  count: z.number().int().describe('Number of rows returned (after limit)'),
});

export type SearchAiModelsInput = z.infer<typeof searchAiModelsInputSchema>;
export type SearchAiModelsOutput = z.infer<typeof searchAiModelsOutputSchema>;

export const searchAiModels: AiTool<undefined, SearchAiModelsInput, SearchAiModelsOutput> = {
  id: 'searchAiModels',

  group: 'ai-models',

  ...aiModelsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description: `Deprecated: prefer findAiModels with searchText. Search AI models by modelName, label, integration (substring), and description (full-text / english stem). Default order is integration then modelName.

Returns id, modelName, integration (provider label, icon, optional subscriptionUSD), label, and description by default. ${AI_TOOL_SELECT_USAGE_NOTE}

By default **enabled and disabled** models are returned. Pass \`onlyEnabled: true\` to restrict to enabled models only.`,
    inputSchema: zodSchema(searchAiModelsInputSchema),
    outputSchema: zodSchema(searchAiModelsOutputSchema),
  }),
};
